import * as React from "react";
import "./LibericaFree.scss";
import {IdHeading} from "components/organisms/IdHeading";
import {ReactNode} from "react";

export type Button = {
  className?: string
  linkText?: string;
  linkUrl?: string;
}

export type LibericaLiItem = {
    imgAlt?: string;
    imgSrc?: string;
    linkText?: string;
    linkUrl?: string;
    pText: ReactNode;
    hText: string;
    hClass?: string
}

export type LibericaLeftBlock = {
    hClass?: string;
    hMaxWidth?: string,
    pClass?: string;
    pMaxWidth?: string,
    hText: string;
    pText: string;
}

const LeftBlock = (props: { leftBlock: LibericaLeftBlock, buttons: Button[] }) => {
  return (
    <>
      <IdHeading headingLevel={2} className={"title " + (props.leftBlock.hClass ? props.leftBlock.hClass : "color-dark")} style={{ maxWidth: props.leftBlock.hMaxWidth}}>{props.leftBlock.hText}</IdHeading>
      <p className={"subtitle " + (props.leftBlock.pClass ? props.leftBlock.pClass : "color-gray")} style={{ maxWidth: props.leftBlock.pMaxWidth}}>{props.leftBlock.pText}</p>

      <div className='buttons'>
        {props.buttons?.map((el, index) =>
            <a key={index} className={"button-filled " + el.className} href={el.linkUrl}>{el.linkText}</a>)}
      </div>
    </>
  );
};

export const LibericaFree = (props: {leftBlock:LibericaLeftBlock, items: LibericaLiItem[], buttons: Button[], background?: string}) => {


  return (
      <div className={props.background ? props.background :"bg-light-gray"}>
          <section className="liberica bs-flex-container transparent">
              <div className="content">
                  <div className="left_column">
                      <LeftBlock
                          leftBlock={props.leftBlock}
                          buttons={props.buttons}
                      />
                  </div>

                  <ul className="right_column">{props.items.map((item, index) => {
                      return (
                          <li className="item" key={`${item.hText}-${index}`}>
                              {item.imgSrc && <img className="icon" src={item.imgSrc} alt={item.imgAlt}></img>}
                              <div className={"item-content"}>
                                  <IdHeading headingLevel={5} className={"title " + (item.hClass ? item.hClass : 'color-dark')}>{item.hText}</IdHeading>
                                  {typeof item.pText === "string" ?
                                      <p className="text">{item.pText}</p>
                                      :
                                      <div className="text">{item.pText}</div>
                                  }
                                  {item.linkText && item.linkUrl &&
                                      <a className="link" href={item.linkUrl}>{item.linkText}</a>}
                              </div>
                          </li>
                      );
                  })}</ul>

                  {/*
                  TODO: images cover the Download button

                  <img className="figure" src={figure} alt="figure"></img>
                  <img className="figure_blur" src={figureBlur} alt="figure blur"></img>
                  <img className="figure_extra" src={figureExtraBlur} alt="figure extra blur"></img> */}
              </div>
          </section>
      </div>
  );
};
